export function sendUtagLink<T>(eventName: string, dataLayer: object, parameters?: T) {
  const obj = {
    event_name: eventName,
    ...parameters,
    ...dataLayer,
  };
  if (typeof window.utag !== 'undefined') {
    window.utag.link(obj);
  }
}

export function sendUtagView<T>(eventName: string, dataLayer: object, parameters?: T) {
  const obj = {
    event_name: eventName,
    ...parameters,
    ...dataLayer,
  };
  if (typeof window.utag !== 'undefined') {
    window.utag.view(obj);
  }
}
